import { z } from 'zod'

const baseAddressSchema = z.object({
  address: z.string(),
  isPrivateHouse: z.boolean().default(false),
  comment: z.string().optional(),
  noIntercomCall: z.boolean().default(false),
  leaveAtDoor: z.boolean().default(false),
  pickup: z.boolean().default(false),
  apartment: z.string().optional(),
  floor: z.string().optional(),
  entrance: z.string().optional(),
  intercom: z.string().optional(),
})

export const userInfoSchema = z.object({
  name: z.string(),
  phone: z.string(),
  isOtherPerson: z.boolean().default(false),
  nameOther: z.string().optional(),
  phoneOther: z.string().optional(),
})

const replacementSchema = z.object({
  replacementOption: z.number(),
  commentBuilder: z.string().optional(),
  packages: z.boolean().default(false),
})

const mergedSchema = baseAddressSchema
  .merge(userInfoSchema)
  .merge(replacementSchema)

export const getOrderFormSchema = (t: (key: string) => string) =>
  mergedSchema.superRefine((data, ctx) => {
    if (data.isOtherPerson) {
      if (!data.nameOther?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('nameOther-error'),
          path: [ 'nameOther' ],
        })
      }
      if (!data.phoneOther?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('phoneOther-error'),
          path: [ 'phoneOther' ],
        })
      }
    }
  })

export type OrderFormValues = z.infer<ReturnType<typeof getOrderFormSchema>>;
